export const isFeatureEnabled = (featureKey: string, features: string[]): boolean => {
	return features.includes(featureKey);
};
